import { appointmentMessages, eventTokens } from './appointmentMessages';

export const messages = {
  ru: {
    title: 'Шаблоны СУ',
    search: 'Поиск шаблонов',
    noResults: 'По вашему запросу ничего не найдено',
    subtitle: 'Одна карточка — до четырёх независимых вариантов по каналам.',
    edit: 'Редактировать шаблон',
    create: 'Создать шаблон',
    back: 'К списку',
    save: 'Сохранить',
    saving: 'Сохранение…',
    saved: 'Шаблон сохранён',
    unsaved: 'Есть изменения',
    discard: 'Есть несохранённые изменения. Покинуть карточку?',
    failed: 'Не удалось выполнить действие',
    nameRequired: 'Укажите название шаблона',
    name: 'Название',
    category: 'Категория',
    variants: 'Варианты по каналам',
    actions: 'Действия',
    loading: 'Загрузка…',
    empty: 'Шаблонов пока нет',
    delete: 'Удалить',
    deleteConfirm: 'Удалить шаблон «{name}»?',
    sync: 'Каталог WABA',
    syncConfirm:
      'Обновить одобренные шаблоны WhatsApp из Wazzup? Другие каналы останутся без изменений.',
    synced: 'Шаблоны WhatsApp обновлены',
    configured: 'Настроен',
    notConfigured: 'Не настроен',
    configure: 'Использовать вариант {channel}',
    independent:
      'Текст, кнопки и вложение этого варианта не меняют другие каналы.',
    missingHint:
      'Вариант не настроен. При отправке текст из другого канала не подставляется.',
    body: 'Текст сообщения',
    image: 'Изображение',
    imagePlaceholder: 'https://… или переменная со ссылкой',
    upload: 'Загрузить изображение',
    uploading: 'Изображение загружается…',
    buttons: 'Кнопки',
    buttonText: 'Надпись',
    buttonType: 'Тип кнопки',
    urlButton: 'Ссылка',
    replyButton: 'Ответ',
    url: 'Ссылка или переменная',
    actionCode: 'Код действия (необязательно)',
    actionHint:
      'Код хранится для сценария. Обработчик действия пока не подключён.',
    removeButton: 'Убрать кнопку',
    addButton: 'Добавить кнопку',
    calendar: 'Календарь',
    calendarDefault: 'Приём в клинике',
    calendarTitle: 'Название события',
    description: 'Описание',
    alarm: 'Напомнить за (минут)',
    smsHint:
      'SMS хранит отдельный короткий текст. Ссылки добавляйте прямо в текст; кнопок и вложений у SMS нет.',
    copyFrom: 'Скопировать из канала…',
    copy: 'Скопировать',
    copyConfirm:
      'Заменить содержимое варианта {channel}? Это независимая копия; связь с исходным каналом не создаётся. Для SMS копируется только текст.',
    preview: 'Предпросмотр · {channel}',
    previewHint:
      'Пример с тестовыми данными. Не отправляет сообщение и не проверяет доставку.',
    sampleData: 'Данные для предпросмотра',
    smsLength: 'Символов: {length}. Число SMS зависит от кодировки провайдера.',
    test: 'Тестовая отправка',
    testWarning:
      'Это реальное сообщение. Сначала сохраните шаблон, выберите точный источник и получателя. Неподдержанные элементы блокируют отправку.',
    source: 'Источник',
    chooseSource: 'Выберите источник',
    recipient: 'Номер телефона или ID чата',
    sendTest: 'Отправить тест',
    testConfirm:
      'Отправить реальное сообщение получателю {to} через «{source}»?',
    sent: 'Отправлено через «{source}»',
    waba: 'Шаблон WhatsApp у провайдера',
    freeText: 'Свободный текст',
    wabaHint:
      'Для WABA нужен одобренный шаблон. Свободный текст сам по себе не даёт права начать переписку.',
    wabaLocked:
      'Текст и кнопки определяются одобренным шаблоном провайдера. Здесь настраиваются значения его переменных.',
    parameter: 'Параметр {number}',
    errors: {
      invalid_preparation_rules:
        appointmentMessages.ru.invalid_preparation_rules,
      invalid_variants: 'Допустимы только MAX, Telegram, WhatsApp и SMS.',
      invalid_variant: 'Некорректная структура варианта.',
      body_required: 'Заполните текст или отключите вариант.',
      invalid_image: 'Укажите HTTP(S)-ссылку или переменную изображения.',
      invalid_buttons: 'Проверьте надписи, ссылки и коды действий кнопок.',
      sms_text_only: 'SMS поддерживает только текст.',
      invalid_calendar: 'Проверьте название события и целое число минут.',
      invalid_waba:
        'Выберите доступный одобренный шаблон WhatsApp и заполните параметры.',
    },
    warnings: {
      callback_not_connected:
        'Действия кнопок ещё не подключены к обработчику. Настройки сохраняются, отправка с такими действиями заблокирована.',
      calendar_not_connected:
        'Настройка календаря сохраняется. Передача календарного вложения ещё не подключена; отправка заблокирована.',
      image_not_connected:
        'Изображение сохраняется для этого канала. Передача изображения этим способом ещё не подключена; отправка заблокирована.',
      whatsapp_url_requires_provider_template:
        'URL-кнопки WhatsApp требуют одобренного шаблона провайдера. Свободный текст с такими кнопками не отправляется.',
    },
  },
  en: {
    title: 'Automation templates',
    search: 'Search templates',
    noResults: 'No matching templates',
    subtitle: 'One card, up to four independent channel variants.',
    edit: 'Edit template',
    create: 'Create template',
    back: 'Back to list',
    save: 'Save',
    saving: 'Saving…',
    saved: 'Template saved',
    unsaved: 'Unsaved changes',
    discard: 'Discard unsaved changes?',
    failed: 'Action failed',
    nameRequired: 'Enter a template name',
    name: 'Name',
    category: 'Category',
    variants: 'Channel variants',
    actions: 'Actions',
    loading: 'Loading…',
    empty: 'No templates yet',
    delete: 'Delete',
    deleteConfirm: 'Delete template “{name}”?',
    sync: 'WABA catalog',
    syncConfirm:
      'Refresh approved WhatsApp templates from Wazzup? Other channels stay unchanged.',
    synced: 'WhatsApp templates updated',
    configured: 'Configured',
    notConfigured: 'Not configured',
    configure: 'Configure {channel} variant',
    independent:
      'Text, buttons and attachment changes do not affect other channels.',
    missingHint:
      'This variant is not configured. Content from another channel will not be substituted.',
    body: 'Message text',
    image: 'Image',
    imagePlaceholder: 'https://… or a URL variable',
    upload: 'Upload image',
    uploading: 'Uploading image…',
    buttons: 'Buttons',
    buttonText: 'Label',
    buttonType: 'Button type',
    urlButton: 'URL',
    replyButton: 'Reply',
    url: 'URL or variable',
    actionCode: 'Action code (optional)',
    actionHint:
      'Stored for scenario actions. The action handler is not connected yet.',
    removeButton: 'Remove button',
    addButton: 'Add button',
    calendar: 'Calendar',
    calendarDefault: 'Clinic appointment',
    calendarTitle: 'Event title',
    description: 'Description',
    alarm: 'Reminder (minutes before)',
    smsHint:
      'SMS has separate text. Include links in the text; SMS has no buttons or attachments.',
    copyFrom: 'Copy from channel…',
    copy: 'Copy',
    copyConfirm:
      'Replace {channel} content with an independent copy? SMS copies text only.',
    preview: 'Preview · {channel}',
    previewHint:
      'Sample data only. This does not send a message or verify delivery.',
    sampleData: 'Preview sample data',
    smsLength:
      'Characters: {length}. SMS segment count depends on provider encoding.',
    test: 'Test send',
    testWarning:
      'This sends a real message. Save first, select the exact source and recipient. Unsupported elements block sending.',
    source: 'Source',
    chooseSource: 'Choose source',
    recipient: 'Phone number or chat ID',
    sendTest: 'Send test',
    testConfirm: 'Send a real message to {to} through “{source}”?',
    sent: 'Sent through “{source}”',
    waba: 'Provider WhatsApp template',
    freeText: 'Free text',
    wabaHint:
      'WABA requires an approved template. Free text alone does not permit initiating a conversation.',
    wabaLocked:
      'Text and buttons come from the approved provider template. Configure its variable values here.',
    parameter: 'Parameter {number}',
    errors: {
      invalid_preparation_rules:
        appointmentMessages.en.invalid_preparation_rules,
      invalid_variants: 'Only MAX, Telegram, WhatsApp and SMS are allowed.',
      invalid_variant: 'Invalid variant structure.',
      body_required: 'Enter text or disable the variant.',
      invalid_image: 'Enter an HTTP(S) image URL or variable.',
      invalid_buttons: 'Check button labels, URLs and action codes.',
      sms_text_only: 'SMS supports text only.',
      invalid_calendar: 'Check the event title and integer reminder minutes.',
      invalid_waba:
        'Select an available approved WhatsApp template and configure its parameters.',
    },
    warnings: {
      callback_not_connected:
        'Button actions are not connected to a handler. Settings are saved, but sending is blocked.',
      calendar_not_connected:
        'Calendar settings are saved. Calendar attachment delivery is not connected; sending is blocked.',
      image_not_connected:
        'The channel image is saved. Image delivery through this path is not connected; sending is blocked.',
      whatsapp_url_requires_provider_template:
        'WhatsApp URL buttons require an approved provider template. Free text with these buttons cannot be sent.',
    },
  },
};
export const CHANNELS = [
  { key: 'max', label: 'MAX' },
  { key: 'telegram', label: 'Telegram' },
  { key: 'whatsapp', label: 'WhatsApp' },
  { key: 'sms', label: 'SMS' },
];
export const TOKENS = [
  ...eventTokens,
  'Приёмы.Список',
  'Приёмы.Количество',
  'Подготовка',
  'Пациент.Имя',
  'Пациент.ПолноеИмя',
  'Пациент.Телефон',
  'Приём.Дата',
  'Приём.Время',
  'Врач',
  'Филиал',
  'Филиал.Адрес',
  'Филиал.Маршрут',
  'Ссылка.Отзыв',
  'Стадия',
  'Пациент.Отчество',
  'Пациент.Фамилия',
  'Врач.Кратко',
  'Клиника',
  'Филиал.Телефон',
  'Филиал.График',
  'Филиал.Информация',
  'Ссылка.Комментарий',
  'Ссылка.Приём',
  'Ссылка.Telegram',
  'Ссылка.Подписка',
  'Изображение',
];
export const SAMPLE = {
  'Пациент.Имя': 'Мария',
  'Пациент.ПолноеИмя': 'Иванова Мария Петровна',
  'Пациент.Телефон': '+7 900 000-00-00',
  'Приём.Дата': '19.09.2026',
  'Приём.Время': '09:00',
  Врач: 'Петров Пётр Николаевич',
  Филиал: 'Пример филиала',
  'Филиал.Адрес': 'Адрес филиала',
  'Филиал.Маршрут': 'https://example.org/route',
  'Ссылка.Отзыв': 'https://example.org/feedback',
  Стадия: 'Подтверждён',
  'Пациент.Отчество': 'Петровна',
  'Пациент.Фамилия': 'Иванова',
  'Врач.Кратко': 'Иванова А.П.',
  Клиника: 'Пример клиники',
  'Филиал.Телефон': '+7 900 000-00-00',
  'Филиал.График': 'с 08:00 до 20:00',
  'Филиал.Информация': 'Информация о посещении филиала',
  'Ссылка.Комментарий': 'https://example.org/review',
  'Ссылка.Приём': 'https://example.org/appointment',
  'Ссылка.Telegram': 'https://example.org/telegram',
  'Ссылка.Подписка': 'https://example.org/subscribe',
  Изображение: '',
};
export const emptyVariant = () => ({
  body: '',
  buttons: [],
  image_url: '',
  ical: {},
  preparation_rules: [],
});
